import algoliasearch from 'algoliasearch'
import { Context } from '@nuxt/types/app'
import { AlgoliaRequest } from '@/infrastructure/network/AlgoliaRequest'

export class APIClient {
  private algolia

  constructor(private ctx: Context) {
    this.algolia = algoliasearch(process.env.ALGOLIA_APP_ID as string, process.env.ALGOLIA_SECRET as string)
  }

  request<U>(request: AlgoliaRequest<U>): Promise<U> {
    return new Promise<U>((resolve, reject) => {
      this.algolia
        .initIndex(request.index)
        .search(request.word, { ...request.hits, cacheable: true })
        .then((data) => {
          resolve(this.parse<U>(data))
        })
        .catch((err) => {
          reject(err)
        })
    })
  }

  async clearCache(index: string) {
    this.algolia.initIndex(index)
    await this.algolia.clearCache()
  }

  // Default parser
  private parse<U>(data: any): U {
    return data
  }
}
